import { RequestActionMeta } from "./types";

export enum RequestActionType {
  InProgress = "IN_PROGRESS",
  Success = "SUCCESS",
  Error = "ERROR",
  Reset = "RESET",
}

export const defaultRequestMeta: RequestActionMeta = {
  shouldResetData: true,
  shouldResetError: true,
};
